var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMainMenuFiles = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.39259V7.49992C17.5 6.57944 16.7538 5.83325 15.8333 5.83325H10.475C10.1992 5.83325 9.94118 5.69675 9.78602 5.46869L8.58115 3.69785C8.42598 3.46977 8.168 3.33325 7.89213 3.33325H4.16667C3.24619 3.33325 2.5 4.07944 2.5 4.99992V15.3474C2.5 16.0759 3.09064 16.6666 3.81923 16.6666V16.6666C4.49144 16.6666 5.05616 16.1611 5.13039 15.493L5.6686 10.6492C5.76238 9.80515 6.47582 9.16658 7.32507 9.16659H16.6665C17.1405 9.16658 17.5922 9.36847 17.9083 9.72171C18.2245 10.075 18.3753 10.5461 18.3229 11.0173L17.86 15.184C17.7662 16.028 17.0528 16.6666 16.2035 16.6666H3.81923",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMainMenuFiles);
export default ForwardRef;